import { _ } from "../../polyglot/polyglot.js";
import { guid } from "../../helpers/string-util.js";
import { widget } from "@foretagsplatsen/widgetjs";
import imageChooserDialog from "../imageChooserDialog.js";

/**
 * Widget displaying an image, and a dialog to update that image.
 *
 * @param {string} [spec.currentImage] - Image to show
 * @param {function} spec.avatarChosenCallback - Callback triggered when a new avatar has been chosen
 * @param {function} spec.avatarDeletedCallback - Callback triggered when an avatar is deleted
 * @param {function} spec.showDeleteButton - Function which should return a truthy value if the receiver needs to display a 'Delete' button to get rid of user's
 */
export default widget.subclass((that, my) => {
	my.initialize = function ({
		currentImage = "/Client/img/avatar-user-grey-lg.png",
		avatarChosenCallback,
		avatarDeletedCallback,
		showDeleteButton,
	}) {
		my.super(...arguments);

		my.currentImage = currentImage;
		my.avatarChosenCallback = avatarChosenCallback;
		my.avatarDeletedCallback = avatarDeletedCallback;
		my.showDeleteButton = showDeleteButton;

		my.imageChooserDialog = imageChooserDialog({
			width: 100,
			height: 100,
			highResolution: true,
			rounded: true,
			header: _("Change avatar"),
		});

		my.imageChooserDialog.onChoose.register((data) => {
			my.avatarChosenCallback(data);
			that.update();
		});
	};

	that.setCurrentImage = function (image) {
		my.currentImage = image;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.div(
			{
				klass: "avatar-settings",
			},
			html.div(
				html.img({
					klass: "user-avatar",
					src: `${my.currentImage}?no-cache=${guid()}`,
				}),
			),
			html.div({ klass: "button-sequence" }, (html) => {
				html.button(
					{
						klass: "btn btn-primary",
						click: my.imageChooserDialog.show,
						"data-test": "change-avatar",
					},
					_("Change"),
				);

				if (my.showDeleteButton()) {
					html.button(
						{
							klass: "btn btn-warning",
							click: () => my.showDeleteConfirmationDialog(),
						},
						_("Delete"),
					);
				}
			}),
		);
	};

	my.showDeleteConfirmationDialog = function () {
		my.confirmDeletion({
			name: _("this avatar"),
			callback: () => my.avatarDeletedCallback(),
		});
	};
});
